// extracted by mini-css-extract-plugin
module.exports = {"container":"packageButtons_container__mFkzd","btn":"packageButtons_btn__1zUxb","btn-prev":"packageButtons_btn-prev__318r2","btn-next":"packageButtons_btn-next__2DMFT"};